import * as types from 'store/types';
import { update } from 'variables/utilities';

const initial = {
	error: null, request: null,
	loading: false, building: null,
};

const started = (state, action) => {
	const buildings = (state.request === 'retrieve') 
												? action.buildings : state.buildings;
	return update( state, {
		request: action.request,
		buildings: buildings,
		error: null, loading: true
	});
};

const succeeded = (state, action) => {
	const buildings = (state.request === 'retrieve') 
												? action.buildings : state.buildings;
	const modifiedDate = (state.request === 'retrieve') 
												? new Date() : state.modifiedDate;

  if(action.buildings) {
    // need to merge the changes with the list...  
	}
	return update( state, {
		modifiedDate: modifiedDate,
		buildings: buildings,
		building: action.building,
		buildingstats: action.buildingstats ? action.buildingstats : state.buildingstats,
		loading: false, notify: true
	});
};

const removed = (state, action) => {
	return update( state, {
		building: null, loading: false
	});
}

const failed = (state, action) => {
	return update( state, {
			error: action.error, loading: false
	});
}

const building = (state = initial, action) => {
	switch ( action.type ) {
		case types.BUILDING_START: 
			return started(state, action);

		case types.BUILDING_SUCCESS: 
			return succeeded(state, action);

		case types.BUILDING_REMOVE: 
			return removed(state, action);

		case types.BUILDING_FAILURE: 
			return failed(state, action);

		default:
			return state;
	}
};

export default building;